import { z } from 'zod';
import { Uuid } from './blocks.js';
export const BUILD_RESULT_ARTIFACT_PREFIX = 'preview-build-result--';
export const BUILD_RESULT_FILENAME = 'preview-build-result.json';
export const PREVIEW_BUILD_RESULT_ARTIFACT_PREFIX = BUILD_RESULT_ARTIFACT_PREFIX;
export const PREVIEW_BUILD_RESULT_FILENAME = BUILD_RESULT_FILENAME;
export const ContentBuildJobId = z
    .string()
    .regex(/^(preview|production):[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}:[1-9][0-9]*:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/);
export const PreviewBuildJobId = ContentBuildJobId;
export function contentBuildResultArtifactName(buildJobId) {
    const job = ContentBuildJobId.parse(buildJobId);
    return `${BUILD_RESULT_ARTIFACT_PREFIX}${job.replaceAll(':', '--')}`;
}
export const previewBuildResultArtifactName = contentBuildResultArtifactName;
export const PreviewBuildResultManifest = z
    .object({
    schema_version: z.literal(1),
    release_id: Uuid,
    build_job_id: ContentBuildJobId,
    run_id: z.string().trim().min(1),
    run_attempt: z.number().int().positive(),
    result: z.literal('ready'),
    artifact_hash: z.string().regex(/^[0-9a-f]{64}$/),
    artifact_prefix: z.string().min(1),
    commit_sha: z.string().regex(/^[0-9a-f]{40}$/),
})
    .strict()
    .superRefine((manifest, context) => {
    const [kind, releaseId] = manifest.build_job_id.split(':');
    if (releaseId !== manifest.release_id) {
        context.addIssue({
            code: 'custom',
            path: ['build_job_id'],
            message: 'Build job must belong to the release',
        });
    }
    const expectedPrefix = `${kind}/releases/${manifest.release_id}/${manifest.artifact_hash}/`;
    if (manifest.artifact_prefix !== expectedPrefix) {
        context.addIssue({
            code: 'custom',
            path: ['artifact_prefix'],
            message: 'Artifact prefix must match the immutable release hash',
        });
    }
});
